import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { useAdditionalFetchDataHelpersPluginCallback } from "../../AdditionalFetchDataHelpersPlugin/index.js";
import { Box } from "../../../../../Box/index.js";
import { Icon } from "../../../../../Icon/index.js";
import { Typography } from "../../../../../Typography/index.js";
import { Link } from "../../../../../Link/index.js";
import { bytesToSize } from "../../../../../format/index.js";
import { WysiwygContext } from "../../../context/index.js";
import { sanitizeUrl } from "../../../utils/index.js";
import { useLogger } from "../../../../../services/hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const File = (t0)=>{
    const $ = c(31);
    const { name, size, id, editable } = t0;
    const contextHelpers = useAdditionalFetchDataHelpersPluginCallback();
    const logger = useLogger();
    const { apiUrl } = useContext(WysiwygContext);
    const [src, setSrc] = useState("");
    let t1;
    if ($[0] !== contextHelpers || $[1] !== id || $[2] !== logger || $[3] !== src) {
        t1 = ()=>{
            if (src) return;
            if (null == contextHelpers ? void 0 : contextHelpers.getAttachmentUrl) {
                if (contextHelpers.getAttachmentUrl) {
                    const fetchAttachmentUrl = ()=>_async_to_generator(function*() {
                            yield contextHelpers.getAttachmentUrl(id).then((res)=>{
                                setSrc(()=>res);
                                return res;
                            }).catch((err)=>{
                                logger.error(err, {
                                    tags: {
                                        vkdoc_error_type: "wysiwyg input file node"
                                    }
                                });
                            });
                        })();
                    fetchAttachmentUrl();
                }
            }
        };
        $[0] = contextHelpers;
        $[1] = id;
        $[2] = logger;
        $[3] = src;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== apiUrl || $[6] !== contextHelpers || $[7] !== id || $[8] !== logger || $[9] !== src) {
        t2 = [
            apiUrl,
            src,
            id,
            contextHelpers,
            logger
        ];
        $[5] = apiUrl;
        $[6] = contextHelpers;
        $[7] = id;
        $[8] = logger;
        $[9] = src;
        $[10] = t2;
    } else t2 = $[10];
    useEffect(t1, t2);
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsx("div", {
            "data-url": ""
        });
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ jsx(Box, {
            p: "12",
            width: 44,
            height: 44,
            bgcolor: "bg.greyscale.primary",
            radius: "s",
            color: "stroke.tertirary",
            children: /*#__PURE__*/ jsx(Icon, {
                name: "attach",
                size: "20",
                color: "stroke.tertirary"
            })
        });
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== name) {
        t5 = /*#__PURE__*/ jsx(Typography, {
            variant: "subtitle2",
            color: "text.light.primary",
            children: name
        });
        $[13] = name;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== size) {
        t6 = bytesToSize(size);
        $[15] = size;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== t6) {
        t7 = /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.dark.secondary",
            children: t6
        });
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== editable || $[20] !== src) {
        t8 = !editable && /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx(Icon, {
                    name: "circle_small_filled",
                    size: "16",
                    color: "text.light.tertirary"
                }),
                /*#__PURE__*/ jsx(Link, {
                    href: sanitizeUrl(src),
                    size: "extraSmall",
                    variant: "primary",
                    stroke: false,
                    target: "_blank",
                    children: "Скачать файл"
                })
            ]
        });
        $[19] = editable;
        $[20] = src;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t7 || $[23] !== t8) {
        t9 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "4",
            children: [
                t7,
                t8
            ]
        });
        $[22] = t7;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    let t10;
    if ($[25] !== t5 || $[26] !== t9) {
        t10 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "2",
            children: [
                t5,
                t9
            ]
        });
        $[25] = t5;
        $[26] = t9;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== id || $[29] !== t10) {
        t11 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            gap: "12",
            id: id,
            children: [
                t3,
                t4,
                t10
            ]
        });
        $[28] = id;
        $[29] = t10;
        $[30] = t11;
    } else t11 = $[30];
    return t11;
};
export { File };
